import { styled } from 'styled-components';

import { bodySmallText, colors, spacing } from '#/theme/theme';

export const SmallFilePickerFilenameBody = styled.div`
  display: flex;
  gap: ${spacing[8]};

  > * {
    /* Make link and remove button position relative so they capture click in place of the input */
    position: relative;
  }
`;

export const SmallFilePickerFilenameText = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
  max-width: 200px;
`;

export const SmallFilePickerFilenameLastUpdated = styled.p`
  ${bodySmallText};
  margin: 0;
  color: ${colors.lightContentGrey};
  white-space: nowrap;
`;
